import styled from 'styled-components';

export const SpinnerWrapper = styled.div`
  position: fixed;
  background: #7d797d2e;
  width: 100%;
  height: 100%;
  z-index: 100;
  min-height: 100vh;
`;

export const SpinnerMessage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -40px;
  margin-left: -100px;
  width: 200px;
  height: 80px;
  text-align: center;
`;
